var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`collapsible ${_vm.open ? 'is-open' : 'is-closed'}`},[_c('div',{staticClass:"header",on:{"click":function($event){_vm.open = !_vm.open}}},[_c('p',{staticClass:"caption"},[_vm._v(" "+_vm._s(_vm.caption)+" ")])]),_c('div',{staticClass:"inner"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }